import { render, staticRenderFns } from "./BillingAddressCard.vue?vue&type=template&id=500ea10a&scoped=true"
import script from "./BillingAddressCard.vue?vue&type=script&lang=ts"
export * from "./BillingAddressCard.vue?vue&type=script&lang=ts"
import style0 from "./BillingAddressCard.vue?vue&type=style&index=0&id=500ea10a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500ea10a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500ea10a')) {
      api.createRecord('500ea10a', component.options)
    } else {
      api.reload('500ea10a', component.options)
    }
    module.hot.accept("./BillingAddressCard.vue?vue&type=template&id=500ea10a&scoped=true", function () {
      api.rerender('500ea10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/BillingAddressCard.vue"
export default component.exports